export class StatoEntita {
  id: string;
  descrizione: string;
  label: string;
  rimosso: boolean;
  constructor() {
    this.id = '0';
  };
}
